// @ts-nocheck
import {
    AccountSettingsManageSubscriptionsStyles,
    manageSubscriptionsStyles,
} from "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions";
import { formGridProps } from "@store/Themes/common/props/form";

Object.assign<AccountSettingsManageSubscriptionsStyles>(manageSubscriptionsStyles, {
    manageSubscriptionsTitle: formGridProps.title,
    manageSubscriptionsCheckbox: {},
    manageSubscriptionsCheckboxGroup: {},
});
